export const navItems = [
    {
        id:1,
        title:"HOME",
        path:"/",
        cName:'nav-item',
       
    },
    {
        id:2,
        title:"EVENTS",
        path:"./events",
        cName:'nav-item',
        
    },
    // {
    //     id:3,
    //     title:"SPONSORS",
    //     path:"./",
    //     cName:'nav-item'
    // },
    {
        id:3,
        title:"GALLERY",
        path:"./gallery",
        cName:'nav-item',
        
    },
    // {
    //     id:4,
    //     title:"ABOUT US",
    //     path:"./aboutus",
    //     cName:'nav-item',
    //     target:"_blank"
    // },
]